var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10831_115013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2033 119.849C62.7354 120.051 57.2674 120.051 51.7994 119.849C23.733 118.818 1.18145 96.2664 0.150195 68.2023C-0.0513672 62.7344 -0.0513672 57.2664 0.150195 51.7984C1.18145 23.732 23.733 1.18047 51.7971 0.149219C57.265 -0.0523438 62.733 -0.0523438 68.201 0.149219C96.265 1.18047 118.819 23.732 119.848 51.7961C120.049 57.2641 120.049 62.732 119.848 68.2C118.817 96.2641 96.265 118.818 68.201 119.847L68.2033 119.849Z",
    fill: "url(#paint0_radial_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2033 119.849C62.7354 120.051 57.2674 120.051 51.7994 119.849C23.733 118.818 1.18145 96.2664 0.150195 68.2023C-0.0513672 62.7344 -0.0513672 57.2664 0.150195 51.7984C1.18145 23.732 23.733 1.18047 51.7971 0.149219C57.265 -0.0523438 62.733 -0.0523438 68.201 0.149219C96.265 1.18047 118.819 23.732 119.848 51.7961C120.049 57.2641 120.049 62.732 119.848 68.2C118.817 96.2641 96.265 118.818 68.201 119.847L68.2033 119.849Z",
    fill: "url(#paint1_radial_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4223 81.0496C87.5559 81.0496 91.7176 76.888 91.7176 71.7543C91.7176 66.6206 87.5559 62.459 82.4223 62.459C77.2886 62.459 73.127 66.6206 73.127 71.7543C73.127 76.888 77.2886 81.0496 82.4223 81.0496Z",
    fill: "url(#paint2_radial_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4223 81.0496C87.5559 81.0496 91.7176 76.888 91.7176 71.7543C91.7176 66.6206 87.5559 62.459 82.4223 62.459C77.2886 62.459 73.127 66.6206 73.127 71.7543C73.127 76.888 77.2886 81.0496 82.4223 81.0496Z",
    fill: "url(#paint3_radial_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4223 81.0496C42.5559 81.0496 46.7176 76.888 46.7176 71.7543C46.7176 66.6206 42.5559 62.459 37.4223 62.459C32.2886 62.459 28.127 66.6206 28.127 71.7543C28.127 76.888 32.2886 81.0496 37.4223 81.0496Z",
    fill: "url(#paint4_radial_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4223 81.0496C42.5559 81.0496 46.7176 76.888 46.7176 71.7543C46.7176 66.6206 42.5559 62.459 37.4223 62.459C32.2886 62.459 28.127 66.6206 28.127 71.7543C28.127 76.888 32.2886 81.0496 37.4223 81.0496Z",
    fill: "url(#paint5_radial_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 90.2116C67.0872 90.2116 73.7739 88.6951 79.6685 86.0069C83.388 84.31 86.463 89.41 83.2239 91.9037C76.795 96.8514 68.7419 99.7928 60.0021 99.7928C51.2622 99.7928 43.2091 96.8514 36.7802 91.9037C33.5388 89.41 36.6138 84.3123 40.3357 86.0069C46.2302 88.6951 52.9169 90.2116 60.0044 90.2116H59.9997Z",
    fill: "url(#paint6_linear_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 90.2116C67.0872 90.2116 73.7739 88.6951 79.6685 86.0069C83.388 84.31 86.463 89.41 83.2239 91.9037C76.795 96.8514 68.7419 99.7928 60.0021 99.7928C51.2622 99.7928 43.2091 96.8514 36.7802 91.9037C33.5388 89.41 36.6138 84.3123 40.3357 86.0069C46.2302 88.6951 52.9169 90.2116 60.0044 90.2116H59.9997Z",
    fill: "url(#paint7_linear_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2884 44.7512C34.3712 43.2652 38.5407 42.7379 42.4993 43.0496C44.9977 43.2465 45.7009 39.6652 43.3102 38.9082C38.5688 37.4058 33.3141 37.3988 28.2798 39.2316C23.2454 41.0644 19.2235 44.4465 16.5563 48.6441C15.2134 50.7605 18.0517 53.0527 19.8399 51.2949C22.6712 48.5105 26.2056 46.2348 30.2884 44.7488V44.7512Z",
    fill: "url(#paint8_linear_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7119 44.7512C85.6291 43.2652 81.4596 42.7379 77.501 43.0496C75.0026 43.2465 74.2994 39.6652 76.6901 38.9082C81.4315 37.4058 86.6861 37.3988 91.7205 39.2316C96.7549 41.0644 100.777 44.4465 103.444 48.6441C104.787 50.7605 101.949 53.0527 100.16 51.2949C97.3291 48.5105 93.7947 46.2348 89.7119 44.7488V44.7512Z",
    fill: "url(#paint9_linear_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4727 94.0434C26.7765 94.0434 31.8867 90.8083 31.8867 86.8176C31.8867 82.8269 26.7765 79.5918 20.4727 79.5918C14.1688 79.5918 9.05859 82.8269 9.05859 86.8176C9.05859 90.8083 14.1688 94.0434 20.4727 94.0434Z",
    fill: "url(#paint10_linear_10831_115013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5273 94.0434C105.831 94.0434 110.941 90.8083 110.941 86.8176C110.941 82.8269 105.831 79.5918 99.5273 79.5918C93.2235 79.5918 88.1133 82.8269 88.1133 86.8176C88.1133 90.8083 93.2235 94.0434 99.5273 94.0434Z",
    fill: "url(#paint11_linear_10831_115013)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10831_115013",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.49 31.2367) scale(82.4133 82.4133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10831_115013",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7775 50.7273) scale(75.7242 75.7242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FE9738",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FE9738",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE9738",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FE9738",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FE9738",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FE9738",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FE9738",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FE9738",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FE9738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FE9738",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FE9738",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FE9738",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FE9738",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FE9738",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FE9738",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FE9738",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FE9738",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10831_115013",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8621 74.623) rotate(180) scale(11.5312 11.5313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10831_115013",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.316 73.191) rotate(180) scale(11.7305 11.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#563435",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F3131",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#432A2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#322123",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2F2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#312123",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3B2627",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4A2E2F",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10831_115013",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.8621 74.623) rotate(180) scale(11.5313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10831_115013",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.316 73.191) rotate(180) scale(11.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#563435",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F3131",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#432A2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#322123",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2F2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#312123",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3B2627",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4A2E2F",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10831_115013",
    x1: 60.0014,
    y1: 99.8186,
    x2: 60.0014,
    y2: 87.8678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10831_115013",
    x1: 60.0014,
    y1: 98.178,
    x2: 60.0014,
    y2: 84.7647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#543333",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#482D2E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#332224",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2022"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10831_115013",
    x1: 30.8256,
    y1: 46.272,
    x2: 26.1802,
    y2: 32.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10831_115013",
    x1: 88.5447,
    y1: 48.0394,
    x2: 91.4604,
    y2: 39.7824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10831_115013",
    x1: 12.4184,
    y1: 68.5204,
    x2: 27.5988,
    y2: 103.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAEE1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEABDF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEA4DC",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE98D7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE87D0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FE71C7",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FE57BB",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FE38AE",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10831_115013",
    x1: 91.4742,
    y1: 68.5199,
    x2: 106.652,
    y2: 103.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAEE1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEABDF",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEA4DC",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE98D7",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE87D0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FE71C7",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FE57BB",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FE38AE",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2AA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10831_115013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/Smile.814fb17f901c644decaa3607b7d583dd.svg";
export { ForwardRef as ReactComponent };